import WorkflowElement from "../../element"

export default class End extends WorkflowElement {
  static get elementName() {
    return "workflow-end"
  }

  initialize(data) {
    if (data) {
      this.dataset.oid = data.id
    }
    if (this.dataset.toggle === "tooltip" && !data.disabled) {
      $(this).tooltip({
        delay: { show: 800 },
        container: "body",
        trigger: "hover"
      })
    }
  }

  compute(roots, json) {
    this.layoutWidth = 155
    this.layoutHeight = 55

    this.dataset.roots = roots
    this.dataset.sources = (json.sources || []).join(" ")

    this.dataset.allowed_action_nodes = json.allowed_action_nodes
    this.dataset.allowed_event_nodes = json.allowed_event_nodes
    this.dataset.allowed_condition_nodes = json.allowed_condition_nodes
  }
}

customElements.get(End.elementName) ||
  customElements.define(End.elementName, End)
